import { KeyValue } from "@/main/models/common";
import { VoucherTypeActionTypes, VoucherTypeTypes } from "./voucherTypeTypes";

export function getVoucherType(): VoucherTypeActionTypes {
	return {
		type: VoucherTypeTypes.GET_VOUCHER_TYPE,
	};
}

export function saveVoucherType(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): VoucherTypeActionTypes {
	return {
		type: VoucherTypeTypes.SAVE_VOUCHER_TYPE,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerVoucherType(): VoucherTypeActionTypes {
	return {
		type: VoucherTypeTypes.RESET_REDUCER_VOUCHER_TYPE,
	};
}
